import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
})
export class AnalyticsComponent implements OnInit {
  public currentLanguageCode: string;

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLanguageCode = this.translate.getBrowserLang();
  }
}
